<template>
  <div
    class="hkl-gray-hint"
    :class="fontSize ? `font-size-${fontSize}`: ''"
  >
    <template v-if="hint">
      {{ hint }}
    </template>
    <slot v-if="!hint" />
  </div>
</template>
<script>
/**
 * @type {import('vue').Component}
 */
const HKLGrayHint = {
  props: {
    hint: {
      type: String,
      default: undefined,
    },
    fontSize: {
      type: Number,
    },
  },
}

export default HKLGrayHint

</script>
<style lang="scss" scoped>
.hkl-gray-hint {
  font-size: 12px;
  color: #878787;
  font-style: italic;
  font-weight: normal;
  @for $size from 8 through 20 {
    &.font-size-#{$size} {
      font-size: #{$size}px;
    }
  }
}
</style>
